// Central site + brand configuration used across all SEO surfaces
// (meta tags, Open Graph, Twitter cards, JSON-LD structured data, sitemap).
//
// This is the marketing website only. The product application lives at a
// separate domain (see PRODUCT_URL). Keep values here in sync with the copy
// shown on the pages themselves.

export const SITE_URL = "https://about.sosmedlead.my.id"; // official marketing website
export const PRODUCT_URL = "https://sosmedlead.my.id"; // the actual product app

export const SITE_NAME = "SocialLead AI";
export const SITE_TAGLINE = "AI Social Lead Discovery & Engagement Platform";
export const SITE_LOCALE = "en_US";
export const SITE_LOCALE_ALT = "id_ID";

export const DEFAULT_TITLE =
  "SocialLead AI — AI Social Lead Discovery & Engagement Platform";
export const TITLE_TEMPLATE = "%s | SocialLead AI";

export const DEFAULT_DESCRIPTION =
  "SocialLead AI discovers high-intent leads from social conversations, scores buying intent with AI, drafts replies for approval, and manages outreach in one CRM. Discover, analyze, engage and convert.";

// Open Graph / social preview image — the branded dashboard banner.
// Per brand guidance this (NOT the logo) is the site-wide social preview.
export const OG_IMAGE = `${SITE_URL}/og_social_lead_1200x630.jpg`;
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;
export const OG_IMAGE_ALT =
  "SocialLead AI dashboard — lead discovery, buying-intent scoring, pipeline and AI engagement automation";

// Brand logo — used only in structured data and favicons (never as OG image).
export const LOGO = `${SITE_URL}/logo.png`;

// Company / publisher
export const COMPANY_NAME = "PT Aimar Kala Sejahtera";
export const COMPANY_LEGAL_NAME = "PT Aimar Kala Sejahtera";
export const SUPPORT_EMAIL = "support@sosmedlead.my.id";
export const CONTACT_EMAIL = "help@aimarkala.com";
export const COUNTRY = "ID";

export const BRAND_COLOR = "#4f46e5";
export const BACKGROUND_COLOR = "#050505";

// Social / same-as profiles (extend as accounts go live).
export const SAME_AS = [PRODUCT_URL];

// Twitter / X handle (leave empty until a real handle exists).
export const TWITTER_SITE = "";

// Canonical route list — single source of truth for <Seo> defaults + sitemap.
export const ROUTES = {
  home: "/",
  contact: "/contact",
  privacy: "/privacy-policy",
  terms: "/terms-of-service",
  dataDeletion: "/data-deletion",
};

export const absoluteUrl = (path = "/") => {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};
